



import { formatDaysToDuration, getAccountList, getAllVehicleNumber, getChartExpense, getUserAccountList, handleKeyDown, handleKeyDownDe, restrictIntegerInput, venderDropdownApi } from '_services';
import { addService, getGstTypeData, getItemsList } from '_services/workShopServices/workShopServices';
import { ButtonHeading, CityDropdownForTrip, CommonInput, CustomSelect, SkeletonInput, VehicleDropdownForTrip } from 'components'
import BootstrapTable from 'components/BootstrapTable';
import { DatePickerComponent } from 'components/common/CommonDatePicker';
import SingleSelectDropdownInfinite from 'components/common/SingleSelectDropdownInfinite/SingleSelectDropdownInfinite';
import { constant } from 'constants/constant';
import { UserContext } from 'context';
import { utils } from 'helper';
import useDocumentTitle from 'hooks/useDocumentTitle';
import { AddAccountingAccount, AddBankAccount, AddEditOwnDriver, AddEditVehicleModal, AddEditVendors, AddExpenseServiceModal, AddWorkShopItemModal, BankListCanvas, PaymentConfirmModal, PayNowAccountNotifyModal } from 'modals';
import React, { useCallback, useState, useEffect, useContext, useMemo } from 'react'
import toast from 'react-hot-toast';
import { useLocation, useNavigate } from 'react-router-dom';
import { StorageServices } from 'utils';
import StorageService from 'utils/StorageServices';
import './addService.css'



const AddService = () => {
    useDocumentTitle("Add Service | T360");
    const navigate = useNavigate()

    // Define columns based on is_gst
    const getColumns = (isGst) => {
        const baseColumns = [
            { header: "Items", accessor: "items" },
            { header: "HSN", accessor: "hsn" },
            { header: "Description", accessor: "description" },
            { header: "Quantity", accessor: "quantity" },
            { header: "Rate", accessor: "rate" },
            { header: "Discount", accessor: "discount" },


        ];

        const gstColumns = [

            { header: "Tax", accessor: "tax" },
            { header: "Tax Amount", accessor: "taxAmount" },
        ];

        const endColumns = [
            { header: "Amount", accessor: "amount" },
            { header: "", accessor: "remove" },
        ];

        if (isGst) {
            return [...baseColumns, ...gstColumns, ...endColumns];
        }
        return [...baseColumns, ...endColumns];
    };

    const addDays = (date, days) => {
        const result = new Date(date);
        result.setDate(result.getDate() + days);
        return result.toISOString().split("T")[0];
    };

    const { state } = useLocation();
    console.log(state)

    const companyId = StorageServices?.getCompanyId()
    const [showInvoice, setShowInvoice] = useState(true)
    const [loading, setLoading] = useState(false)
    const initialform = {
        company_id: companyId,
        service_type: "Service Center",
        service_date: new Date().toISOString().split("T")[0],
        // vehicle_id: state?.vehicleData?._id ? { ...state?.vehicleData, name: `${state?.vehicleData?.vehicle_no}`, ownershipStatus: 1 } : "",
        vehicle_id: { label: "", value: "" },
        odometer: "",
        is_invoice: showInvoice,
        vendor_type: 4,
        vendor_id: "",
        invoice_number: "",
        invoice_date: new Date().toISOString().split("T")[0],
        due_date: new Date().toISOString().split("T")[0],
        is_gst: 0,
        sub_total: 0,
        discount: 0,
        tds: 0,
        adjustment: 0,
        total_amount: 0,
        payment_mode: 0,
        account_category: "",
        account_sub_category: "",
        account_id: "",
        vendor_bank_account: ""
    };
    const { masterData, bankDetails, setBankDetails } = useContext(UserContext);
    const [form, setForm] = useState(initialform)
    const [expenseList, setExpenseList] = useState([])
    const [expenseCategoryList, setCategoryExpenseList] = useState([]);
    const [showModal, setShowModal] = useState(false)
    const [modalType, setModalType] = useState("Expenses")
    const [formErrors, setFormErrors] = useState({})
    const [showModalPart, setShowPart] = useState(false)
    const [expenseAccount, setExpenseAccount] = useState([]);
    const [accountLoading, setAccountLoading] = useState(false);
    const [accountList, setAccountList] = useState([]);
    const [isCheck, setIsCheck] = useState(false);
    const [bankRequiredDetails, setBankRequiredDetails] = useState({})
    const [bankAccountList, setBankAccountList] = useState([]);
    const [canvasOpen, setCanvasOpen] = useState(false);
    const [showAddBank, setShowAddBank] = useState(false);
    const [venderDetails, setVenderDetails] = useState({
        vender_type: 0,
        vender_id: ''

    })
    const [accountAddShow, setAccountAddShow] = useState(false);
    const [showOffcanvas, setShowOffcanvas] = useState(false);
    const [showOffcanvasVendor, setShowOffcanvasVendor] = useState(false);
    const [refreshVehicleDropdown, setRefreshVehicleDropdown] = useState(0);
    const [isDriver, setIsDriver] = useState(false);
    const [showOffcanvasOfDriver, setShowOffcanvasOfDriver] = useState(false);
    const [gstTypeList, setGstTypeList] = useState([]);


    const [isOpenFreight, setIsOpenFreight] = useState({ open: false, type: "" });
    const [easeBuzzId, setEaseBuzzId] = useState("")
    const [payNowAccountCreate, setpayNowAccountCreate] = useState(false);
    const [isOpenPayNow, setIsOpenPayNow] = useState(false)
    const [eaesbuzzId, setEaesbuzzId] = useState({
        eb_account_id: "",
        total_amount: 0
    })
    const [isProcessing, setIsProcessing] = useState(false);
    const [isSuccessOpen, setIsSuccessOpen] = useState(false);
    const [paymentData, setPaymentData] = useState({
        voucher_id: "",
        data: {}
    })
    const [isMakeStatusOpen, setIsMakeStatusOpen] = useState(false);

    // Calculate totals whenever expense list or form values change
    useEffect(() => {
        getExpenseHandler()
        getMasterFreight();
        getGstTypeList()
    }, [masterData])

    useEffect(() => {
        if (state?.data) {
            populateFormWithData(state.data);
        }
    }, [state]);

    const populateFormWithData = (data) => {
        console.log("Populating form with:", data);

        // ✅ Set form fields
        setForm({
            company_id: data.company_id || companyId,
            service_type: data.service_type || "Service Center",
            service_date: data.service_date
                ? new Date(data.service_date).toISOString().split("T")[0]
                : new Date().toISOString().split("T")[0],

            // ✅ Vehicle data
            vehicle_id: data.vehicle ? {
                _id: data.vehicle._id,
                label: `${data.vehicle.vehicle_no} | ${masterData?.vehicle_ownership[data.vehicle.vehicle_ownership]}`,
                value: data.vehicle._id,
                vehicle_no: data.vehicle.vehicle_no,
                vehicle_ownership: data.vehicle.vehicle_ownership,
                lorry_type_id: data.vehicle.lorry_type_id,
                vehicle_type_id_1: data.vehicle.vehicle_type_id,
                last_kms: data.vehicle.last_kms,
                ownershipStatus: data.vehicle.vehicle_ownership
            } : { label: "", value: "" },

            odometer: data.odometer || "",
            is_invoice: data.is_invoice || false,
            vendor_type: data.vendor_type || 4,

            // ✅ Vendor data
            vendor_id: data.vendor_detail ? {
                _id: data.vendor_detail._id,
                label: data.vendor_detail.name,
                value: data.vendor_detail._id,
                name: data.vendor_detail.name
            } : "",

            invoice_number: data.invoice_number || "",
            invoice_date: data.invoice_date
                ? new Date(data.invoice_date).toISOString().split("T")[0]
                : new Date().toISOString().split("T")[0],
            due_date: data.due_date
                ? new Date(data.due_date).toISOString().split("T")[0]
                : new Date().toISOString().split("T")[0],

            is_gst: data.is_gst || 0,
            sub_total: data.sub_total || 0,
            discount: data.discount || 0,
            tds: data.tds || 0,
            adjustment: data.adjustment || 0,
            total_amount: data.total_amount || 0,
            payment_mode: data.payment_mode || 0,
            account_category: data.payment_type ? masterData?.account_category?.id : "",
            account_sub_category: data.payment_type || "",
            account_id: "", // Will be set after account list loads
            vendor_bank_account: ""
        });

        // ✅ Set invoice toggle
        setShowInvoice(data.is_invoice || false);

        // ✅ Transform items to expenseList
        if (data.items && data.items.length > 0) {
            const transformedItems = data.items.map((item, index) => ({
                id: item._id || Date.now() + index,
                _id: item._id,

                // ✅ Item/Category
                item_id: item.item,
                category: {
                    label: item.item.name || item.item.label,
                    value: item.item._id || item.item.value,
                    name: item.item.name,
                    ...item.item
                },

                hsn_code: item.hsn_code || "",
                description: item.description || "",
                qty: item.qty || 0,
                rate: item.rate || 0,
                discount: item.discount || 0,

                // ✅ Tax
                tax: item.tax ? {
                    label: `${item.tax} %`,
                    value: item.tax
                } : { label: "0 %", value: 0 },

                tax_amount: item.tax_amount || 0,
                amount: item.amount || 0,
                base_amount: (item.qty || 0) * (item.rate || 0),

                // ✅ Item type
                item_type: item.item_type || 3,

                // ✅ Reminder data
                reminder: item.reminder || 0,
                next_meter_interval: item.next_meter_interval || 0,
                original_next_meter_interval: item.item?.odometer_kms || 0,

                next_reminder_days: item.next_reminder_days ? {
                    label: formatDaysToDuration(item.next_reminder_days),
                    value: item.next_reminder_days
                } : "",

                next_reminder_date: item.completion_date
                    ? new Date(item.completion_date)
                    : null,
                original_next_reminder_date: item.completion_date
                    ? new Date(item.completion_date)
                    : null,
            }));

            setExpenseList(transformedItems);
        }
    };

    useEffect(() => {
        if (state?.vehicleData?._id) {
            setForm((pre) => {
                return {
                    ...pre,
                    vehicle_id: state?.vehicleData?._id ? {
                        ...state?.vehicleData,
                        name: `${state?.vehicleData?.vehicle_no}`,
                        ownershipStatus: state?.vehicleData?.vehicle_ownership || 1,
                        last_kms: state?.vehicleData?.last_kms || 0
                    } : { label: "", value: "", name: "" },
                }
            })

        }
    }, [state?.vehicleData])

    useEffect(() => {
        if (form?.invoice_date) {
            const dueDate = addDays(form.invoice_date, 2);
            setForm(prevItems => ({
                ...prevItems,
                due_date: dueDate,
                due_date_days: {
                    label: "2 Days",
                    value: 2
                }
            }));
        }
    }, [form?.invoice_date]);

    useEffect(() => {

        setForm(prev => ({
            ...prev,
            odometer: form.vehicle_id.last_kms || 0
        }));

    }, [form?.vehicle_id?._id]);


    useEffect(() => {


        if (expenseList.length > 0) {
            setExpenseList(prevItems =>
                prevItems.map(item => {
                    // Only update items that have odometer-based reminders
                    if (item?.item_id?.odometer_reading === 1) {
                        const currentOdometer = Number(form.odometer);
                        const addedKm = Number(item?.item_id?.odometer_kms || 0);
                        const newNextMeterInterval = currentOdometer + addedKm;

                        return {
                            ...item,
                            next_meter_interval: newNextMeterInterval
                        };
                    }
                    return item;
                })
            );
        }
    }, [form?.odometer, expenseList.length]);

    useEffect(() => {
        if (form.is_gst === 0) {
            setExpenseList(prevItems =>
                prevItems.map(item => {
                    const qty = Number(item.qty) || 0;
                    const rate = Number(item.rate) || 0;
                    const discount = Number(item.discount) || 0;

                    const baseAmount = qty * rate;
                    const amountAfterDiscount = baseAmount - discount;

                    return {
                        ...item,
                        tax: 0,
                        tax_amount: 0,
                        amount: amountAfterDiscount
                    };
                })
            );
        }
    }, [form.is_gst]);

    const getGstTypeList = async () => {
        try {
            let object = { company_id: StorageService.getCompanyId() }
            const res = await getGstTypeData();
            if (res?.responseCode === 200) {
                let array = res?.data?.map((el) => {
                    return {
                        ...el,
                        label: `${el?.perc} %`,
                        value: el?.perc
                    }
                })
                setGstTypeList(array);
            } else {
                toast.error(res?.responseMessage);
            }
        } catch (error) {
        }
    }

    const fetchItem = async (search, page, limit) => {
        const res = await getItemsList({
            company_id: companyId,
            offset: page,
            limit,
            search,

        });
        if (res?.responseCode === 200) {
            const list = res?.data?.itemData?.map((i) => ({
                ...i,
                label: i?.name,
                value: i?._id,
            }));
            return {
                items: list,
                total: res?.data?.total_record,
            };
        } else {
            return { items: [], total: 0 };
        }
    };

    const fetchVehicle = async (search, page, limit) => {
        const res = await getAllVehicleNumber({
            company_id: companyId,
            offset: page,
            limit,
            search,
            vehicle_ownership: [1, 3]
        });
        if (res?.responseCode === 200) {
            const list = res?.data?.vehicle_list?.map((i) => ({
                ...i,
                name: `${i?.vehicle_no}`,
                ownershipStatus: i?.vehicle_ownership,
            }));
            return {
                items: list,
                total: res?.data?.total_record,
            };
        } else {
            return { items: [], total: 0 };
        }
    };

    const fetchVendor = useCallback(async (search, page, limit) => {
        try {
            const response = await venderDropdownApi({
                company_id: StorageService.getCompanyId(),
                offset: page,
                limit,
                search,
            });

            if (response?.responseCode === 200) {
                const vendors = response.data.vendor_list.map(vendor => ({
                    ...vendor,
                    label: vendor.name,
                    value: vendor._id
                }));

                return {
                    items: vendors,
                    total: response.data.total_record || vendors.length,
                };
            }

            toast.error(response?.responseMessage);
            return { items: [], total: 0 };
        } catch (error) {
            console.error("Error fetching vendors:", error);
            return { items: [], total: 0 };
        }
    }, []);

    const getExpenseHandler = async () => {
        try {
            const res = await getChartExpense({
                company_id: StorageService.getCompanyId(),
                category_id: 5,
                sub_category_id: 8,
            });

            if (res?.responseCode === 200) {
                const details = res?.data?.categories?.map((item) => {
                    return {
                        label: item?.name,
                        value: item?._id,
                    };
                });
                setCategoryExpenseList(details?.reverse());
            }
        } catch (error) {
            console.error("Error fetching expense categories:", error);
        }
    };

    const handleAddExpense = (type) => {
        setModalType(type);
        setShowModal(true);
    };

    console.log(expenseList)
    const handleExpenseSubmit = (expenseData) => {

        let updatedData = {
            ...expenseData,

            // Category + HSN
            ...(expenseData?.item_id && {
                category: expenseData.item_id,
                hsn_code: expenseData?.item_id?.hsn_code
            }),

            // Item type mapping
            item_type: modalType === "Expenses" ? 3 : modalType === 1 ? 1 : 2,
        };

        // -----------------------------
        // TIME-INTERVAL REMINDER
        // -----------------------------
        if (expenseData?.item_id?.time_interval === 1) {

            const days = Number(expenseData?.item_id?.time_interval_days || 0);

            const today = new Date();
            const next = new Date(today);
            next.setDate(today.getDate() + days);

            updatedData.next_reminder_days = {
                label: `${days} days`,
                value: String(days)
            };
            updatedData.next_reminder_date = next;
            updatedData.original_next_reminder_date = next
        }

        // -----------------------------
        // METER-INTERVAL REMINDER
        // -----------------------------
        if (expenseData?.item_id?.odometer_reading === 1) {

            const lastKm = Number(form?.odometer || 0);
            const addedKm = Number(expenseData?.item_id?.odometer_kms || 0);
            const totalKm = lastKm + addedKm;

            updatedData.next_meter_interval = totalKm;
            updatedData.original_next_meter_interval = addedKm;
        }

        // Set Reminder flag
        updatedData.reminder =
            expenseData?.item_id?.odometer_reading === 1 ||
                expenseData?.item_id?.time_interval === 1
                ? 1
                : 0;


        // -----------------------------
        // 🔥 CALCULATE AMOUNT HERE ITSELF
        // -----------------------------

        const qty = Number(updatedData.qty || 0);
        const rate = Number(updatedData.rate || 0);

        // Tax object OR number both supported
        const tax = typeof updatedData.tax === "object"
            ? Number(updatedData.tax.value || 0)
            : Number(updatedData.tax || 0);

        const discount = Number(updatedData.discount || 0);

        // Base = Qty × Rate
        const baseAmount = qty * rate;

        // Amount after discount
        const taxableAmount = baseAmount - discount;

        // Tax calculation
        const taxAmount =
            form.is_gst === 1 && tax > 0
                ? (taxableAmount * tax) / 100
                : 0;

        // Final amount
        const finalAmount = taxableAmount + taxAmount;

        updatedData.base_amount = baseAmount;
        updatedData.tax_amount = taxAmount;
        updatedData.amount = finalAmount;


        // -----------------------------
        // ADD ITEM TO LIST
        // -----------------------------
        setExpenseList((prev) => [...prev, updatedData]);

        toast.success("Added successfully");
        setShowModal(false);
    };


    const handleRemoveExpense = (id) => {
        setExpenseList(expenseList.filter(item => item.id !== id));

    };


    const handleExpenseChange = (id, field, value) => {
        setExpenseList(prev =>
            prev.map(item => {

                if (item.id !== id) return item;

                let updatedItem = { ...item, [field]: value };
                console.log(updatedItem.original_next_meter_interval)
                // ----- Auto clear reminders -----
                // if (field == "reminder" && value == 0) {
                //     updatedItem.next_reminder_days = 0;
                //     updatedItem.next_meter_interval = 0;
                // }

                // ----- Auto clear / restore reminders -----
                if (field === "reminder") {
                    if (value == 0) {
                        // Clear values when unchecked
                        updatedItem.next_reminder_days = "";
                        updatedItem.next_meter_interval = "";
                    } else {
                        // Restore original values when checked again
                        if (updatedItem?.item_id?.odometer_reading === 1) {
                            updatedItem.next_meter_interval = updatedItem.original_next_meter_interval || "";
                            if (form?.odometer != 0) {
                                updatedItem.next_meter_interval = updatedItem.original_next_meter_interval + Number(form?.odometer);

                            } else {

                                updatedItem.next_meter_interval = updatedItem.original_next_meter_interval;
                            }
                        }
                        if (updatedItem?.item_id?.time_interval === 1) {
                            if (updatedItem.original_next_reminder_date) {
                                updatedItem.next_reminder_date = updatedItem.original_next_reminder_date;

                                // Recalculate days from today
                                const today = new Date();
                                const reminderDate = new Date(updatedItem.original_next_reminder_date);
                                const diffDays = Math.ceil((reminderDate - today) / (1000 * 60 * 60 * 24));
                                const formattedLabel = formatDaysToDuration(diffDays);

                                updatedItem.next_reminder_days = {
                                    label: formattedLabel,
                                    value: diffDays
                                };
                            }
                        }
                    }
                }
                if (field === "next_reminder_date") {
                    const today = new Date();
                    const reminderDate = new Date(value);
                    const diffDays = Math.ceil((reminderDate - today) / (1000 * 60 * 60 * 24));
                    const formattedLabel = formatDaysToDuration(diffDays);
                    updatedItem.next_reminder_days = {
                        label: formattedLabel,
                        value: diffDays
                    };

                    // Also update the original when manually changed
                    // updatedItem.original_next_reminder_date = value;
                }

                // ----- Next Reminder Date -----
                // if (field === "next_reminder_date") {
                //     const today = new Date();
                //     const reminderDate = new Date(value);
                //     const diffDays = Math.ceil((reminderDate - today) / (1000 * 60 * 60 * 24));
                //     const formattedLabel = formatDaysToDuration(diffDays);
                //     updatedItem.next_reminder_days = {
                //         label: formattedLabel,
                //         value: diffDays
                //     };
                // }





                // ----- AMOUNT CALCULATION -----
                if (['qty', 'rate', 'tax', 'discount'].includes(field)) {

                    const qty = Number(field === 'qty' ? value : item.qty || 0);
                    const rate = Number(field === 'rate' ? value : item.rate || 0);

                    // Get tax %
                    const tax = field === 'tax'
                        ? Number(typeof value === "object" ? value.value : value)
                        : Number(typeof item.tax === "object" ? item.tax.value : item.tax || 0);

                    let discount = Number(field === "discount" ? value : item.discount || 0);

                    // Base = Qty × Rate
                    const baseAmount = qty * rate;

                    // ✅ Validate: Discount cannot exceed base amount
                    if (discount > baseAmount) {
                        discount = baseAmount;
                        updatedItem.discount = baseAmount; // Cap the discount
                    }

                    // Calculate tax on discounted value
                    const taxableAmount = baseAmount - discount;
                    const tax_amount = form.is_gst === 1 && tax > 0
                        ? (taxableAmount * tax) / 100
                        : 0;

                    // Final Item Amount
                    const finalItemAmount = taxableAmount + tax_amount;

                    updatedItem.base_amount = baseAmount;
                    updatedItem.tax_amount = tax_amount;
                    updatedItem.amount = finalItemAmount;
                }

                return updatedItem;
            })
        );

        // ----- CLEAR FIELD ERRORS -----
        setFormErrors(prev => {
            const newErrors = { ...prev };
            if (newErrors[`item_${id}`]?.[field]) {
                delete newErrors[`item_${id}`][field];
                if (Object.keys(newErrors[`item_${id}`]).length === 0)
                    delete newErrors[`item_${id}`];
            }
            return newErrors;
        });
    };



    const calculateTotals = useCallback(() => {
        // Total of each item (already includes discount & tax)
        const subTotal = expenseList.reduce(
            (sum, item) => sum + (Number(item.amount) || 0),
            0
        );

        let discountOnBill = Number(form.discount) || 0;
        let tds = Number(form.tds) || 0;
        const adjustment = Number(form.adjustment) || 0;

        // ✅ Validate: Discount cannot exceed subtotal
        if (discountOnBill > subTotal) {
            discountOnBill = subTotal;
            setForm(prev => ({ ...prev, discount: subTotal.toFixed(2) }));
        }

        // ✅ Validate: TDS cannot exceed (subtotal - discount)
        const amountAfterDiscount = subTotal - discountOnBill;
        if (tds > amountAfterDiscount) {
            tds = amountAfterDiscount;
            setForm(prev => ({ ...prev, tds: amountAfterDiscount.toFixed(2) }));
        }

        // Final Net Total
        const totalAmount = subTotal - discountOnBill - tds + adjustment;

        setForm(prev => ({
            ...prev,
            sub_total: subTotal.toFixed(2),
            total_amount: Math.max(0, totalAmount).toFixed(2) // ✅ Prevent negative total
        }));
    }, [expenseList, form.discount, form.tds, form.adjustment]);

    const handleVehicleChange = (data) => {
        setForm((prev) => ({
            ...prev,
            vehicle_id: data,
        }))
        // Clear error when field is updated
        if (formErrors.vehicle_id) {
            setFormErrors(prev => ({ ...prev, vehicle_id: "" }))
        }
    }

    const handleInvoiceToggle = (e) => {
        const checked = e.target.checked;
        setShowInvoice(checked);

        if (!checked) {
            setForm((prev) => ({
                ...prev,
                vendor_id: "",
                invoice_number: "",
                invoice_date: new Date().toISOString().split("T")[0],
                due_date: new Date().toISOString().split("T")[0],
                is_gst: 0,
                is_invoice: false
            }))
            // Clear invoice related errors
            setFormErrors({})
        } else {
            setForm((prev) => ({
                ...prev,
                is_invoice: true
            }))
        }
    }

    const handleInputChange = (name, value) => {

        const regex = /^-?\d*\.?\d{0,2}$/;
        if (name === "adjustment" && !regex.test(value)) {
            return;
        }

        // ✅ Calculate due_date_days when due_date changes
        if (name === "due_date") {
            if (!form?.invoice_date) {
                console.error("Invoice date is not set");
                return;
            }

            const invoiceDate = new Date(form.invoice_date);
            const dueDate = new Date(value);

            // ✅ Validate dates
            if (isNaN(invoiceDate.getTime()) || isNaN(dueDate.getTime())) {
                console.error("Invalid date provided");
                return;
            }

            const diffDays = Math.ceil((dueDate - invoiceDate) / (1000 * 60 * 60 * 24));
            const formattedLabel = formatDaysToDuration(diffDays);
            // ✅ Update both due_date and due_date_days
            setForm((prev) => ({
                ...prev,
                due_date: value,
                due_date_days: {
                    label: formattedLabel,
                    value: diffDays
                }
            }));

            // Clear errors
            if (formErrors.due_date) {
                setFormErrors(prev => ({ ...prev, due_date: "" }));
            }
            return; // ✅ Early return since we already updated the form
        }


        // ✅ Normal update for other fields
        setForm((prev) => ({
            ...prev,
            [name]: value
        }));

        // Clear error when field is updated
        if (formErrors[name]) {
            setFormErrors(prev => ({ ...prev, [name]: "" }));
        }
    }



    const validateForm = () => {
        const errors = {};

        // Basic validations
        if (!form.vehicle_id?._id) {
            errors.vehicle_id = "Please select a vehicle";
        }

        if (!form.service_date) {
            errors.service_date = "Please select service date";
        }

        // Account validation
        if (form.account_sub_category != 11 && form.account_sub_category != 15) {
            if (!form.account_id) {
                errors.account_id = "Please select an account";
            }
        }

        if (form.account_sub_category == 2 && isCheck == true && form?.is_invoice) {
            if (!form.vendor_bank_account) {
                errors.vendor_bank_account = "Please select an vendor bank account";
            }
        }
        if (form.account_sub_category == 28 && isCheck == true && form?.is_invoice) {
            if (!form.vendor_bank_account) {
                errors.vendor_bank_account = "Please select an vendor bank account";
            }
        }


        // Invoice validations
        if (showInvoice && form.is_invoice) {
            if (!form.vendor_id) {
                errors.vendor_id = "Please select a vendor";
            }

            if (!form.invoice_number || form.invoice_number.trim() === "") {
                errors.invoice_number = "Please enter invoice number";
            }

            if (!form.invoice_date) {
                errors.invoice_date = "Please select invoice date";
            }

            if (!form.due_date) {
                errors.due_date = "Please select due date";
            }

            // Validate due date is at least 2 days after invoice date
            if (form.invoice_date && form.due_date) {
                const invoiceDate = new Date(form.invoice_date);
                const dueDate = new Date(form.due_date);

                // Calculate difference in days
                const diffTime = dueDate - invoiceDate;
                const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

                if (diffDays < 2) {
                    errors.due_date = "Due date must be at least 2 days after invoice date";
                }
            }
        }

        // Expense list validation
        if (!expenseList || expenseList.length === 0) {
            errors.expense_list = "Please add at least one expense item";
            toast.error("Please add at least one expense item");
        } else {
            // Validate each expense item
            let hasExpenseErrors = false;

            expenseList.forEach((item, index) => {
                const itemErrors = {};

                // Validate Category
                if (!item.category || !item.category.value) {
                    itemErrors.category = "Category is required";
                    hasExpenseErrors = true;
                }

                // Validate HSN Code (required only when GST is enabled)
                if (form.is_gst === 1) {
                    if (!item.hsn_code || item.hsn_code.trim() === "") {
                        itemErrors.hsn_code = "HSN code is required when GST is enabled";
                        hasExpenseErrors = true;
                    }
                }

                // Validate Quantity
                if (!item.qty || item.qty <= 0) {
                    itemErrors.qty = "Quantity must be greater than 0";
                    hasExpenseErrors = true;
                }

                // Validate Rate
                if (item.rate === undefined || item.rate === null || item.rate === "") {
                    itemErrors.rate = "Rate is required";
                    hasExpenseErrors = true;
                } else if (Number(item.rate) < 0) {
                    itemErrors.rate = "Rate cannot be negative";
                    hasExpenseErrors = true;
                }

                // Validate Tax (required only when GST is enabled)
                if (form.is_gst === 1) {
                    if (!item.tax && item.tax === 0) {
                        itemErrors.tax = "Tax rate is required when GST is enabled";
                        hasExpenseErrors = true;
                    }
                }

                // Validate Amount
                // if (!item.amount || item.amount <= 0) {
                //     itemErrors.amount = "Amount must be greater than 0";
                //     hasExpenseErrors = true;
                // }

                // Store errors for this item if any
                if (Object.keys(itemErrors).length > 0) {
                    errors[`item_${item.id}`] = itemErrors;
                }
            });

            // Show toast for expense item errors
            if (hasExpenseErrors) {
                toast.error("Please fill all required fields in expense items");
            }
        }

        setFormErrors(errors);
        return Object.keys(errors).length === 0;
    };

    // Handle form submission
    const handleSubmit = async () => {

        // Check if there are items but total is 0 or less
        if (expenseList.length > 0 && Number(form.total_amount) <= 0) {
            toast.error("Total amount must be greater than zero");
            return;
        }

        console.log("validateForm", validateForm())
        if (validateForm()) {
            // Prepare payload
            // Format expenses for API
            const formattedExpenses = expenseList.map(expense => ({
                item: {
                    _id: expense.category.value,
                    name: expense.category.name || expense.category.label,
                    ...(expense?.item_id?._id ? expense.category : {})
                },
                tax: Number(expense.tax.value) || 0,
                hsn_code: expense.hsn_code || "",
                description: expense.description || "",
                type: expense.item_type || "Goods",
                amount: parseFloat(Number(expense.amount).toFixed(2)),
                tax_amount: expense?.tax_amount,
                discount: expense?.discount,
                reminder: expense?.reminder ? Number(expense?.reminder) : 0,
                next_meter_interval: expense?.reminder ? Number(expense?.next_meter_interval || 0) : 0,
                next_reminder_days: expense?.reminder ? Number(expense?.next_reminder_days?.value || 0) : 0,
                item_type: expense?.item_type

            }));

            // Prepare payload matching API structure
            const payload = {
                company_id: form.company_id,
                service_type: form.service_type,
                service_date: new Date(form.service_date).toISOString(),
                vehicle_id: form.vehicle_id._id || "",
                odometer: form.odometer || "",
                is_invoice: form.is_invoice || "",
                vendor_type: form.vendor_type || "",
                vendor_id: form.is_invoice && form.vendor_id ? form.vendor_id._id : "",
                invoice_number: form.is_invoice ? form.invoice_number : "",
                invoice_date: form.is_invoice ? new Date(form.invoice_date).toISOString() : "",
                due_date: form.is_invoice ? new Date(form.due_date).toISOString() : "",
                is_gst: Number(form.is_gst),
                sub_total: parseFloat(form.sub_total),
                discount: parseFloat(Number(form.discount).toFixed(2)),
                tds: parseFloat(Number(form.tds).toFixed(2)),
                adjustment: parseFloat(Number(form.adjustment).toFixed(2)),
                total_amount: parseFloat(form.total_amount),
                items: formattedExpenses,
                payment_mode: Number(form?.payment_mode),
                account_category: Number(form?.account_category),
                account_sub_category: Number(form?.account_sub_category),
                account_id: form?.account_id || "",
                vendor_bank_account: form?.vendor_bank_account || ""
            };
            // console.log(payload)
            try {
                setLoading(true)

                if (form?.account_sub_category == 28) {
                    callbackEaesbuzz(
                        easeBuzzId,
                        form?.amount,
                        {
                            vendor_bank_account: {
                                account_name: bankDetails?.account_name,
                                account_number: bankDetails?.account_number,
                                account_type: bankDetails?.account_type,
                                bank_name: bankDetails?.bank_name,
                                ifsc_code: bankDetails?.ifsc_code,
                                upi_id: bankDetails?.upi_id
                            }
                        },
                        payload
                    );
                    setIsOpenPayNow(true)
                    return
                }

                const res = await addService(payload)

                if (res?.responseCode === 200) {
                    toast.success(res?.responseMessage)
                    navigate("/WorkshopServicing")
                }

            } catch (error) {

            } finally {
                setLoading(false)
            }

        } else {

        }
    };

    const getMasterFreight = async () => {
        try {
            const details = masterData?.account_category?.sub_category?.map(
                (item) => {
                    return {
                        label: item?.name,
                        value: item?.id,
                        category_id: masterData?.account_category?.id,
                    };
                }
            );

            const detailsAccount =
                masterData?.account_category?.sub_category
                    ?.filter((k) => k.id !== 15 && k.id !== 26 && k.id !== 27 && k.id !== 28)
                    ?.map((item) => {
                        return {
                            label: item?.name,
                            value: item?.id,
                            category_id: masterData?.account_category?.id,
                        };
                    })
                    ?.concat({
                        label: "To Pay",
                        value: 15,
                        category_id: masterData?.account_category?.id,
                    });

            const order = [15, 3, 2, 27, 14, 28];
            const sortedData = detailsAccount.sort(
                (a, b) => order.indexOf(a.value) - order.indexOf(b.value)
            );

            if (sortedData && details) {
                setForm({
                    ...form,
                    account_category:
                        sortedData[0]?.category_id,
                    account_sub_category:
                        sortedData[0]?.value

                });

                setExpenseAccount(sortedData);
            }
        } catch { }
    };

    const callBackAddAccount = () => {
        setCanvasOpen(true);
        getVenderAccountListHandler(venderDetails);
    }

    const callBackAccount = () => {
        getAccountListHandler("new")
    }

    const venderDetailsFun = (data) => {
        setVenderDetails(data)
    }

    useEffect(() => {
        if (venderDetails?.vender_id) {
            getVenderAccountListHandler(venderDetails);
        }
    }, [venderDetails]);



    const getVenderAccountListHandler = async (venderDetailsPara) => {
        try {
            const res = await getAccountList({
                company_id: StorageService?.getCompanyId(),
                vendor_type: venderDetailsPara?.vender_type,
                vendor_id: venderDetailsPara?.vender_id?._id,
            });

            if (res?.responseCode === 200) {
                const details = res?.data?.bank_account?.map((item) => {

                    return {
                        ...item,
                        label: item?.bank_name || item?.account_name || item?.upi_id,
                        value: item?._id,
                    };
                });
                setBankAccountList(details);
            } else {
            }
        } catch (error) {
        }
    };

    const getAccountListHandler = async (newParam = "") => {
        setAccountLoading(true);
        try {
            const res = await getUserAccountList({
                company_id: StorageService?.getCompanyId(),
                category_id: parseInt(form?.account_category ?? 1),
                sub_category_id: parseInt(form?.account_sub_category),
            });

            if (res?.responseCode === 200) {
                setAccountLoading(false);
                const details = res?.data?.account_list?.map((item) => {
                    return {
                        ...item,
                        label: item?.name,
                        value: item?._id,
                    };
                });
                if (details?.length) {
                    const lastItem = details[details.length - 1];

                    setAccountList(details);
                    handleInputChange(
                        "account_id",
                        newParam === "new"
                            ? (lastItem?.value ?? "")
                            : (details?.[0]?.value ?? "")
                    );

                    setBankRequiredDetails(newParam == "new" ? lastItem : details[0])
                    if (form?.account_sub_category == 28) {
                        setEaseBuzzId(details[0]?.eb_account_id)

                    } else {
                        setEaseBuzzId("")
                    }
                } else {
                    if (details.length == 0 && form?.account_sub_category == 28) {
                        setpayNowAccountCreate(true)
                    }

                    setForm((prev) => ({
                        ...prev,
                        account_id: "", // fallback or reset
                    }));
                }

            } else {
                setAccountLoading(false);
                setAccountList([]);
            }
        } catch (error) {
            setAccountList([]);
        }
    };

    const callbackEaesbuzz = (id, amount, venderDetails, payload) => {

        setEaesbuzzId((pre) => ({
            ...pre, eb_account_id: id,
            total_amount: amount,
            vendor_bank_account: venderDetails?.vendor_bank_account,
            payload: payload
        }))
    }

    useEffect(() => {
        if (
            (form?.account_sub_category && form?.account_category,
                expenseAccount.length)
        ) {

            if (form?.account_id == "" && form?.account_category) {
                getAccountListHandler();
            }
        }
    }, [
        form?.account_sub_category,
        form?.account_category,
        expenseAccount,
        form?.account_id,
    ]);

    useEffect(() => {
        let value = false;

        // 1️⃣ bankRequiredDetails rule
        if (bankRequiredDetails?.vendor_account === true && form?.account_sub_category == 2 && form?.is_invoice) {
            value = true;
        }

        // 2️⃣ form/account rules
        if (form?.account_id === "") {
            value = false;
        }

        if (bankRequiredDetails?.vendor_account === true && form?.account_sub_category == 28 && form?.is_invoice) {
            value = true;
        }
        // Final update in one place:
        setIsCheck(value);

    }, [
        bankRequiredDetails,
        form?.account_sub_category,
        form?.account_id,
    ]);


    useEffect(() => {
        setForm((pre) => ({ ...pre, account_id: "" }))
    }, [form?.account_sub_category])


    const callSelectDateWiseFunction = (id, date, data) => {

        let finalDate = utils.getDateAfterDays(date, data?.value)

        setExpenseList(prev =>
            prev.map(item => {

                if (item.id === id) {
                    const updatedItem = { ...item };
                    updatedItem.next_reminder_date = finalDate;

                    return updatedItem;
                }
                return item;
            }))
    }

    const callBackServiceData = (data) => {

        const objest = {
            description: "",
            store_id: {},
            quantity: '',
            rate: '',
            discount: '',
            tax: {},
            amount: ''
        }

        const detailsdata = {
            id: Date.now(), _id: data?._id,
            item_id: {
                label: data?.name,
                value: data?._id,

                ...data
            }, ...objest
        }

        console.log("detailsdata", detailsdata)

        handleExpenseSubmit(detailsdata)
        setShowPart(false)
    }

    const addAccountHandle = () => {
        setAccountAddShow(true);
    };

    const accountClose = () => {
        setShowAddBank(false);
        setCanvasOpen(true);
    };

    const rowListData = (data) => {
        return data?.map((item, i) => {

            const baseRow = {
                items: (
                    item?.item_id?._id ?
                        <SingleSelectDropdownInfinite
                            label="Item"
                            fetchData={fetchItem}
                            selectedItem={item?.category}
                            onChange={(data) => handleExpenseChange(item.id, "category", data)}
                            loadOnOpen={true}
                            error={formErrors.category}
                            errorMessage={formErrors.category}
                            singleDropClass="__minHdrop"
                            disabled={state?.data?._id}
                        /> :
                        <div style={{ minWidth: '142px' }}>
                            <CustomSelect
                                label="Expense Category"
                                placeholder="Select Category"
                                options={expenseCategoryList}
                                value={item.category || null}
                                onSelect={(data) => handleExpenseChange(item.id, "category", data)}
                                disabled={state?.data?._id}
                            />
                        </div>
                ),
                hsn: (

                    <CommonInput
                        type="text"
                        className="form-control"
                        value={item.hsn_code}
                        onChange={(e) => handleExpenseChange(item.id, 'hsn_code', e.target.value)}
                        placeholder="HSN"
                        style={{ minWidth: '100px' }}
                        error={formErrors[`item_${item.id}`]?.hsn_code}
                        focus={formErrors[`item_${item.id}`]?.hsn_code}
                        errorShow={false}
                        maxLength={6}
                        disabled={state?.data?._id}
                    />
                ),
                description: (

                    <CommonInput
                        type="text"
                        className="form-control"
                        value={item.description}
                        onChange={(e) => handleExpenseChange(item.id, 'description', e.target.value)}
                        placeholder="Description"
                        style={{ minWidth: '300px', width: "100%" }}
                        error={formErrors[`item_${item.id}`]?.description}
                        focus={formErrors[`item_${item.id}`]?.description}
                        errorShow={false}
                        maxLength={50}
                        disabled={state?.data?._id}
                    />
                ),
                quantity: (
                    <CommonInput
                        type="text"
                        className="form-control"
                        value={item.qty}
                        onChange={({ target: { value } }) => {
                            // ✅ Restrict to integers only (no decimal, no dot)
                            const restrictedValue = restrictIntegerInput(value);

                            // Only update if valid integer
                            if (restrictedValue !== null) {
                                handleExpenseChange(item.id, 'qty', restrictedValue);
                            }
                        }}
                        placeholder="0"
                        min="0"
                        style={{ minWidth: '80px', width: 100 }}
                        error={formErrors[`item_${item.id}`]?.qty}
                        focus={formErrors[`item_${item.id}`]?.qty}
                        errorShow={false}
                        onKeyDown={(e) => handleKeyDownDe(e, 0)} // ✅ 0 = no decimals allowed
                        maxLength={5}
                        disabled={state?.data?._id}
                    />
                ),
                rate: (
                    <CommonInput
                        type="text"
                        className="form-control"
                        value={item.rate}
                        // onChange={(e) => handleExpenseChange(item.id, 'rate', e.target.value)}
                        onChange={({ target: { name, value } }) => {
                            if (/^0[0-9]/.test(value)) {
                                value = value.replace(/^0+/, ''); // "01" → "1"
                            }

                            // Allow "0." for decimals but not "0x" where x is digit
                            if (value === "0") {
                                handleExpenseChange(item.id, "rate", value);
                                return;
                            }
                            handleExpenseChange(item.id, 'rate', value)
                        }}
                        placeholder="0.00"
                        min="0"
                        step="0.01"
                        error={formErrors[`item_${item.id}`]?.rate}
                        focus={formErrors[`item_${item.id}`]?.rate}
                        errorShow={false}
                        style={{ minWidth: '80px', width: 100 }}
                        onKeyDown={handleKeyDown}
                        maxLength={10}
                        disabled={state?.data?._id}
                    />
                ),
                discount: (
                    <CommonInput
                        type="text"
                        className="form-control"
                        value={item.discount}
                        // onChange={(e) => handleExpenseChange(item.id, 'discount', e.target.value)}
                        onChange={({ target: { name, value } }) => {
                            if (/^0[0-9]/.test(value)) {
                                value = value.replace(/^0+/, ''); // "01" → "1"
                            }

                            // Allow "0." for decimals but not "0x" where x is digit
                            if (value === "0") {
                                handleExpenseChange(item.id, "discount", value);
                                return;
                            }
                            handleExpenseChange(item.id, 'discount', value)
                        }}
                        placeholder="0.00"
                        min="0"
                        step="0.01"
                        error={formErrors[`item_${item.id}`]?.discount}
                        focus={formErrors[`item_${item.id}`]?.discount}
                        errorShow={false}
                        style={{ minWidth: '80px', width: 100 }}
                        onKeyDown={handleKeyDown}
                        maxLength={5}
                        disabled={state?.data?._id}
                    />
                ),
            };

            // Add HSN and Tax columns only if is_gst is 1
            if (form.is_gst === 1) {
                baseRow.tax = (
                    <div className='__taxV_crtl'>
                        <CustomSelect
                            label="Tax"
                            placeholder="Select"
                            options={gstTypeList}
                            value={item.tax || null}
                            onSelect={(data) => handleExpenseChange(item.id, "tax", data)}
                            error={formErrors[`item_${item.id}`]?.tax}
                            focus={formErrors[`item_${item.id}`]?.tax}
                            errorShow={false}
                            disabled={state?.data?._id}
                        />
                    </div>
                );

                baseRow.taxAmount = (
                    <div className='__taxM_ctrl'>
                        <CommonInput
                            type="number"
                            className="form-control"
                            value={item.tax_amount}
                            onChange={(e) => handleExpenseChange(item.id, 'tax_amount', e.target.value)}
                            placeholder="0.00"
                            min="0"
                            step="0.01"
                            error={formErrors[`item_${item.id}`]?.tax_amount}
                            focus={formErrors[`item_${item.id}`]?.tax_amount}
                            errorShow={false}
                            style={{ minWidth: '80px', width: 100 }}
                            onKeyDown={handleKeyDown}
                            disabled={true}

                        />
                    </div>
                );
            }


            // Add amount and remove columns
            baseRow.amount = (
                <div className='__taxM_ctrl'>
                    <CommonInput
                        type="text"
                        className="form-control"
                        value={`₹${Number(item.amount).toFixed(2)}`}
                        placeholder="0.00"
                        disabled
                        style={{ minWidth: '80px', width: 100 }}
                        // error={formErrors[`item_${item.id}`]?.amount}
                        // focus={formErrors[`item_${item.id}`]?.amount}
                        errorShow={false}

                    />
                </div>
            );

            baseRow.remove = (
                <button
                    className="btn btn-sm"
                    onClick={() => handleRemoveExpense(item.id)}
                    style={{ padding: '4px 4px', background: "#FFE8E8", display: "flex", alignItems: "center", justifyContent: "center" }}
                >
                    <div style={{ width: "20px", borderRadius: "50%", background: "#D62727", color: "#ffff" }}>-</div>
                </button>
            );
            if (item?.item_type !== 3) {

                const hasOdometer = Boolean(item?.item_id?.odometer_reading);
                const hasTimeInterval = Boolean(item?.item_id?.time_interval);
                // const isReminderActive = hasOdometer || hasTimeInterval;
                const isReminderActive =
                    item?.reminder !== undefined
                        ? item.reminder
                        : (hasOdometer || hasTimeInterval);

                //  const isReminderActive = expenseList.find(x => x.id === item.id)?.reminder === 1;

                baseRow.expandContent = (
                    <div className="__remindBgx">
                        <div className="_anvSwitcherNew form-check form-switch" style={{ minWidth: '220px' }} >
                            <label htmlFor="">Service Reminder</label>
                            <input
                                className="form-check-input"
                                type="checkbox"
                                name="reminder"
                                checked={isReminderActive}
                                // disabled={isReminderActive}
                                autoComplete="off"
                                onChange={(e) => handleExpenseChange(item.id, 'reminder', e.target.checked ? 1 : 0)}
                                disabled={!(hasOdometer || hasTimeInterval) || state?.data?._id}
                            />
                        </div>
                        {isReminderActive == 1 && <> {hasOdometer && (
                            <div style={{ minWidth: "262px" }}>
                                <CommonInput
                                    label="Next Meter Interval"
                                    type="text"
                                    placeholder="Next Meter Interval"
                                    name="next_meter_interval"
                                    value={item?.next_meter_interval || ""}
                                    onChange={(e) => {
                                        const value = e.target.value;

                                        // ❌ block starting with 0
                                        if (value.length === 1 && value === "0") return;

                                        // optional: allow only numbers
                                        if (!/^\d*$/.test(value)) return;

                                        handleExpenseChange(item.id, "next_meter_interval", value);
                                    }}
                                    maxLength={6}
                                    onKeyDown={handleKeyDown}
                                    disabled={state?.data?._id}
                                />
                            </div>
                        )}

                            {hasTimeInterval && (<div className='__selectAddon' style={{ position: 'relative' }}>
                                <DatePickerComponent
                                    label="Next Reminder Days"
                                    name='next_reminder_date'
                                    showTimeSelect={false}
                                    defaultTimeFix={false}
                                    startDate={item.next_reminder_date}
                                    onChange={(data) => handleExpenseChange(item.id, 'next_reminder_date', data)}
                                    error={!!(typeof formErrors === "object") ? formErrors?.next_reminder_date : ""}
                                    min={new Date()}
                                    disabled={state?.data?._id}
                                />
                                <div className='__inrDropdown_bx'>
                                    <CustomSelect
                                        options={constant.invoiceDueDateArray}
                                        name="next_reminder_days"
                                        disabled={(!form?.service_date ? true : false || state?.data?._id)}
                                        placeholder="Custom"
                                        value={item?.next_reminder_days?.value ? item?.next_reminder_days : {}}
                                        // onSelect={(data) => {
                                        //     handleExpenseChange(item.id, 'next_reminder_days', data,);
                                        //     callSelectDateWiseFunction(item.id, item?.time_interval_days, data);
                                        // }}

                                        onSelect={(data) => {
                                            if (data.value === "custom") {
                                                // Do nothing — let user pick date manually
                                                // Optionally: you can clear the field or show calendar
                                                return;
                                            }
                                            // For fixed days (15, 30, etc.)
                                            const newDate = utils.getDateAfterDays(new Date(form.service_date), data.value);
                                            handleExpenseChange(item.id, 'next_reminder_date', newDate);
                                            // Note: handleExpenseChange will auto-set next_reminder_days via date logic
                                        }}

                                    />
                                </div>
                            </div>


                            )}</>}

                    </div>
                )
            }

            return baseRow;
        });
    };

    // const expenseProps = {
    //     headerPart: false,
    //     modalMainClass: "_dashCommon_Modal _smModal",
    //     modalTitle: `Add ${modalType} ${form?.is_gst === 1 ? `(with GST)` : `(without GST)`}`,
    //     submitTitle: `Add ${modalType}`,
    //     isOpen: showModal,
    //     closeModal: () => setShowModal(false),
    //     onSubmitExpense: handleExpenseSubmit,
    //     expenseType: modalType,
    //     is_gst: form?.is_gst,
    //     expenseCategoryList: expenseCategoryList,
    //     gstTypeList: gstTypeList
    // }

    // const expensePropsPart = {
    //     headerPart: false,
    //     modalMainClass: "_lgModal", // "_xxlModal",
    //     modalTitle: `Add ${modalType == 1 ? "Parts" : "Service"}`,
    //     submitTitle: `Add ${modalType == 1 ? "Parts" : "Service"}`,
    //     isOpen: showModalPart,
    //     closeModal: () => setShowPart(false),
    //     onSubmitExpense: handleExpenseSubmit,
    //     expenseType: modalType,
    //     is_gst_chareged: form?.is_gst_chareged,
    //     expenseCategoryList: expenseCategoryList,
    //     expenseList: expenseList,
    //     callBackServiceData: callBackServiceData
    // }

    // let bankListProps = {
    //     setCanvasOpen: setCanvasOpen,
    //     canvasOpen: canvasOpen,
    //     setShowAddBank: setShowAddBank,
    //     accountList: bankAccountList,
    //     setIsOpenFreight: setIsOpenFreight,
    //     venderDetails: venderDetails
    // };


    // let firstAddBank = {
    //     isOpen: showAddBank,
    //     closeModal: accountClose,
    //     headerPart: false,
    //     modalMainClass: "_dashCommon_Modal _smModal",
    //     modalTitle: "Add Bank Account",
    //     submitTitle: "Continue",
    //     callBackAddAccount: callBackAddAccount,
    //     venderDetails: venderDetails
    // };

    // let AddTransactionAccountModal = {
    //     isOpen: accountAddShow,
    //     closeModal: (e) => setAccountAddShow(false),
    //     modalMainClass: "_dashCommon_Modal _mdModal",
    //     modalTitle: "Add Account ",
    //     footerPart: true,
    //     submitTitle: "Add Account",
    //     callBackAddAccount: callBackAccount
    // }

    useEffect(() => {
        calculateTotals();
    }, [calculateTotals]);



    useEffect(() => {
        if (expenseList?.length == 0) {
            setForm((pre) => ({ ...pre, discount: 0, tds: 0, adjustment: 0, total_amount: 0, amount: 0 }))

        }
    }, [expenseList])

    useEffect(() => {
        if (form?.is_invoice) {
            setForm((pre) => ({ ...pre, account_sub_category: 15, due_date: addDays(form?.invoice_date, 2) }))
        } else {
            setForm((pre) => ({ ...pre, account_sub_category: 3, due_date: addDays(form?.invoice_date, 2) }))

        }
    }, [form?.is_invoice])

    useEffect(() => {

        if (bankDetails) {

            setForm({ ...form, vendor_bank_account: bankDetails?._id });
            setFormErrors((pre) => ({ ...pre, vendor_bank_account: "" }))

        }
    }, [bankDetails]);

    console.log(form)

    useEffect(() => {
        if (!isCheck) {
            setBankDetails("");
            if (form?.vendor_bank_account) {
                setForm((prev) => ({
                    ...prev,
                    vendor_bank_account: "",
                }));
            }
        } else {
            setForm((prev) => ({
                ...prev,
                vendor_bank_account: bankAccountList[0]?._id,
            }));
            setBankDetails(bankAccountList[0]);
            setFormErrors((pre) => ({ ...pre, vendor_bank_account: "" }))
        }
    }, [isCheck]);

    useEffect(() => {
        setBankDetails("");
        setForm((prev) => ({
            ...prev,
            vendor_bank_account: "",
        }));

    }, [form?.vendor_id?.value]);

    const addVehicleHandle = (data) => {
        setShowOffcanvas(true);
    };


    const addVehicleHandleVendor = (data) => {
        setShowOffcanvasVendor(true);
    };

    const callBackVehicle = async (data) => {
        setForm((pre) => ({
            ...pre, vehicle_id: {
                ...data,
                label: `${data.vehicle_no} | ${masterData?.vehicle_ownership[data?.vehicle_ownership]}`,
            },
        }))
        setTimeout(() => {
            setRefreshVehicleDropdown(prev => prev + 1);
        }, 2000);
    };

    const handleAddNewVehicleButtonAction = () => {
        setIsDriver(false);
        setShowOffcanvasOfDriver(true);
    };

    const handleDriverNextModal = () => {
        setIsDriver(!isDriver);
        setShowOffcanvas(true);
    };

    const callBackVendor = async (data) => {

        setForm((pre) => ({ ...pre, vendor_id: { ...data, label: data?.name, value: data?._id } }));

    }


    // ============================================
    // MODAL PROPS
    // ============================================

    const expenseProps = useMemo(() => ({
        headerPart: false,
        modalMainClass: "_dashCommon_Modal _smModal",
        modalTitle: `Add ${modalType} ${form?.is_gst === 1 ? `(with GST)` : `(without GST)`}`,
        submitTitle: `Add ${modalType}`,
        isOpen: showModal,
        closeModal: () => setShowModal(false),
        onSubmitExpense: handleExpenseSubmit,
        expenseType: modalType,
        is_gst: form?.is_gst,
        expenseCategoryList: expenseCategoryList,
        gstTypeList: gstTypeList
    }), [modalType, form?.is_gst, showModal, expenseCategoryList, gstTypeList, handleExpenseSubmit]);

    const expensePropsPart = useMemo(() => ({
        headerPart: false,
        modalMainClass: "_lgModal",
        modalTitle: `Add ${modalType === 1 ? "Parts" : "Service"}`,
        submitTitle: `Add ${modalType === 1 ? "Parts" : "Service"}`,
        isOpen: showModalPart,
        closeModal: () => setShowPart(false),
        onSubmitExpense: handleExpenseSubmit,
        expenseType: modalType,
        is_gst_chareged: form?.is_gst_chareged,
        expenseCategoryList: expenseCategoryList,
        expenseList: expenseList,
        callBackServiceData: callBackServiceData
    }), [modalType, showModalPart, form?.is_gst_chareged, expenseCategoryList, expenseList, handleExpenseSubmit, callBackServiceData]);

    const bankListProps = useMemo(() => ({
        setCanvasOpen: setCanvasOpen,
        canvasOpen: canvasOpen,
        setShowAddBank: setShowAddBank,
        accountList: bankAccountList,
        setIsOpenFreight: setIsOpenFreight,
        venderDetails: venderDetails
    }), [canvasOpen, bankAccountList, venderDetails]);

    const firstAddBank = useMemo(() => ({
        isOpen: showAddBank,
        closeModal: accountClose,
        headerPart: false,
        modalMainClass: "_dashCommon_Modal _smModal",
        modalTitle: "Add Bank Account",
        submitTitle: "Continue",
        callBackAddAccount: callBackAddAccount,
        venderDetails: venderDetails
    }), [showAddBank, accountClose, callBackAddAccount, venderDetails]);

    const AddTransactionAccountModal = useMemo(() => ({
        isOpen: accountAddShow,
        closeModal: () => setAccountAddShow(false),
        modalMainClass: "_dashCommon_Modal _mdModal",
        modalTitle: "Add Account",
        footerPart: true,
        submitTitle: "Add Account",
        callBackAddAccount: callBackAccount
    }), [accountAddShow, callBackAccount]);

    let payNowAccountProps = {
        isOpen: payNowAccountCreate,
        closeModal: (e) => {
            setpayNowAccountCreate(false)
            setForm((pre) => ({ ...pre, account_sub_category: 3 }));
        },
        modalMainClass: "_dashCommon_Modal _mdModal",
        modalTitle: "Pay Now",
        // headerPart: true,
        footerPart: true,
        submitTitle: "Create Account",
        callBackAddAccount: callBackAddAccount
    }

    let payNowProps = {
        isOpen: isOpenPayNow,
        closeModal: (e) => setIsOpenPayNow(false),
        setIsProcessing, setIsProcessing,
        setIsOpenPayNow: setIsOpenPayNow,
        easebuzzDetails: eaesbuzzId
    }

    return (
        <div className='__addService_ws_main'>
            <ButtonHeading title="Add Servicing" />
            <div className='__addSer_mid_part'>
                <div className='checkBx_lv mt-2' style={{ width: '100%' }}>
                    {
                        constant.ServiceAddRadio?.map((el, ind) => {
                            return (
                                <React.Fragment key={ind}>
                                    <div className='_dualCheckr_bx' style={{ maxWidth: '140px', width: '100%' }}>
                                        <input
                                            style={{ marginTop: '2px' }}
                                            className="form-check-input"
                                            id={+ind + "pay_type" + el?.value}
                                            type="radio"
                                            name="service_type"
                                            checked={form?.service_type === el?.value}
                                            value={form?.service_type ? form?.service_type : ""}
                                            onChange={({ target: { name } }) =>
                                                handleInputChange(name, el?.value)
                                            }
                                            disabled={state?.data?._id}
                                        />
                                        <label style={{ fontSize: '14px' }} htmlFor={+ind + "pay_type" + el.value} className="form-check-label" >
                                            {el.label}
                                        </label>
                                    </div>
                                </React.Fragment>
                            )
                        })
                    }
                </div>

                <div className='__adS_main_fx'>
                    <div className='halfDiv'>
                        <VehicleDropdownForTrip
                            label='Vehicle Number'
                            placeholder="Vehicle Number"
                            fetchData={fetchVehicle}
                            selectedItem={form?.vehicle_id}
                            onChange={handleVehicleChange}
                            loadOnOpen={true}
                            error={formErrors.vehicle_id}
                            errorMessage={formErrors.vehicle_id}

                            isAddButton={true}
                            addButtonAction={(e) => addVehicleHandle(e)}
                            pageSize={7}
                            refreshTrigger={refreshVehicleDropdown}
                            disabled={state?.data?._id}
                        />

                    </div>

                    <div className='halfDiv'>
                        {/* <CommonInput
                            type="date"
                            placeholder="Service Date"
                            label="Service Date"
                            name='service_date'
                            value={form?.service_date}
                            onChange={(e) => handleInputChange('service_date', e.target.value)}
                            error={formErrors.service_date}
                        /> */}
                        <DatePickerComponent
                            label="Service Date"
                            name="service_date"
                            showTimeSelect={false}
                            defaultTimeFix={false}
                            startDate={form?.service_date}
                            max={new Date()}
                            onChange={(data) => handleInputChange('service_date', data)}
                            error={!!(typeof formErrors === "object") ? formErrors.service_date : ""}
                            disabled={state?.data?._id}
                        />
                    </div>

                    <div className='singleDiv'>
                        <CommonInput
                            type="text"
                            placeholder="Last Odometer Reading"
                            label="Last Odometer Reading"
                            name='odometer'
                            value={form?.vehicle_id ? form?.odometer : ""}
                            // onChange={(e) => handleInputChange('odometer', e.target.value)}
                            onChange={({ target: { name, value } }) => {
                                if (/^0[0-9]/.test(value)) {
                                    value = value.replace(/^0+/, ''); // "01" → "1"
                                }

                                // Allow "0." for decimals but not "0x" where x is digit
                                if (value === "0") {
                                    handleInputChange(name, value);
                                    return;
                                }
                                handleInputChange(name, value)
                            }}
                            onKeyDown={(e) => handleKeyDown(e, 3)}
                            maxLength={6}
                            disabled={state?.data?._id}
                        />
                    </div>

                    <div className='singleDiv'>
                        <div className='__addInvoice_switch'>
                            <h6>Add Invoice</h6>

                            <div className="_anvSwitcherNew form-check form-switch" >
                                <input
                                    className="form-check-input"
                                    type="checkbox"
                                    name="actStatus"
                                    checked={showInvoice}
                                    autoComplete="off"
                                    onChange={handleInvoiceToggle}
                                    disabled={state?.data?._id}
                                />
                            </div>
                        </div>
                    </div>

                    {/* Conditionally render invoice fields */}
                    {showInvoice && (
                        <>
                            <div className='halfDiv'>
                                <CityDropdownForTrip
                                    label="Vendor"
                                    placeholder="Select Vendor"
                                    fetchData={fetchVendor}
                                    pageSize={20}
                                    onChange={(data) => {
                                        handleInputChange("vendor_id", data);
                                    }}
                                    selectedItem={form.vendor_id ? form?.vendor_id : null}
                                    error={formErrors.vendor_id}
                                    errorMessage={formErrors.vendor_id}
                                    isAddButton={true}
                                    addButtonAction={(e) => addVehicleHandleVendor(e)}
                                    isClearOption={form.vendor_id?.label ? true : false}
                                    isClearHandleChange={(e) => setForm((s) => ({ ...s, vendor_id: {} }))}
                                    disabled={state?.data?._id}
                                />

                            </div>

                            <div className='halfDiv'>
                                <CommonInput
                                    type="text"
                                    placeholder="Invoice Number"
                                    label="Invoice Number"
                                    name='invoice_number'
                                    value={form?.invoice_number}
                                    onChange={(e) => handleInputChange('invoice_number', e.target.value)}
                                    maxLength={10}
                                    error={formErrors.invoice_number}
                                    disabled={state?.data?._id}
                                />
                            </div>

                            <div className='halfDiv'>

                                <DatePickerComponent
                                    label="Invoice Date"
                                    name="invoice_date"
                                    showTimeSelect={false}
                                    defaultTimeFix={false}
                                    startDate={form?.invoice_date}
                                    max={new Date()}
                                    onChange={(data) => handleInputChange('invoice_date', data)}
                                    error={!!(typeof formErrors === "object") ? formErrors.invoice_date : ""}
                                    disabled={state?.data?._id}
                                />
                            </div>

                            <div className='halfDiv'>

                                <div className='' style={{ position: 'relative' }}>
                                    <DatePickerComponent
                                        label="Due Date"
                                        name="due_date"
                                        showTimeSelect={false}
                                        defaultTimeFix={false}
                                        startDate={form?.due_date}
                                        // max={form?.due_date}
                                        min={form?.invoice_date}
                                        onChange={(data) => handleInputChange('due_date', data)}
                                        error={!!(typeof formErrors === "object") ? formErrors.due_date : ""}
                                        disabled={state?.data?._id}
                                    />
                                    <div className='__inrDropdown_bx'>
                                        <CustomSelect
                                            options={constant.invoiceDueDateArray}
                                            name="due_date_days"
                                            // disabled={!form?.due_date_days}
                                            placeholder="Custom"
                                            value={form?.due_date_days?.value ? form?.due_date_days : {}}
                                            onSelect={(data) => {
                                                handleInputChange('due_date_days', data);

                                                // Auto-calculate due date based on invoice date + selected days
                                                if (form?.invoice_date && data?.value) {
                                                    const invoiceDate = new Date(form.invoice_date);
                                                    const dueDate = new Date(invoiceDate);
                                                    dueDate.setDate(dueDate.getDate() + Number(data.value));
                                                    handleInputChange('due_date', dueDate);
                                                }
                                            }}
                                            disabled={state?.data?._id}
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className='checkBx_lv mt-0 p-0' style={{ width: '100%' }}>
                                {
                                    constant.GstAddRadio?.map((el, ind) => {
                                        return (
                                            <React.Fragment key={ind}>
                                                <div className='_dualCheckr_bx' style={{ maxWidth: '140px', width: '100%' }}>
                                                    <input
                                                        style={{ marginTop: '2px' }}
                                                        className="form-check-input"
                                                        id={+ind + "is_gst" + el?.value}
                                                        type="radio"
                                                        name="is_gst"
                                                        checked={form?.is_gst === el?.value}
                                                        value={el?.value}
                                                        onChange={(e) => handleInputChange('is_gst', el?.value)}
                                                        disabled={state?.data?._id}
                                                    />
                                                    <label style={{ fontSize: '14px' }} htmlFor={+ind + "is_gst" + el.value} className="form-check-label" >
                                                        {el.label}
                                                    </label>
                                                </div>
                                            </React.Fragment>
                                        )
                                    })
                                }
                            </div>
                        </>
                    )}
                </div>

                <BootstrapTable
                    tableClass={expenseList.length > 0 ? "__serviceTable_bx" : "__serviceTable_bx __serviceTableEmpty_bx"}
                    columns={getColumns(form.is_gst === 1)}
                    colSpanTb={form.is_gst === 1 ? 8 : 6}
                    data={rowListData(expenseList)}
                    name="service"
                />

                <div className='__subsMain_bx'>
                    <div className='__subsLeft_bx'>
                        <button
                            className='__adTab_servBtn anime-btn'
                            // onClick={() => handleAddExpense("Parts")}
                            onClick={() => {
                                setModalType(1)
                                setShowPart(true)
                            }

                            }
                            disabled={state?.data?._id}
                        >
                            + Add Parts
                        </button>
                        <button
                            className='__adTab_servBtn anime-btn'
                            // onClick={() => handleAddExpense("Services")}
                            onClick={() => {
                                setModalType(2)
                                setShowPart(true)
                            }}
                            disabled={state?.data?._id}
                        >
                            + Add Services
                        </button>
                        <button
                            className='__adTab_servBtn anime-btn'
                            onClick={() => handleAddExpense("Expenses")}
                            disabled={state?.data?._id}
                        >
                            + Add Expenses
                        </button>
                    </div>

                    <div className='__subsRight_bx'>
                        <table>
                            <tbody>
                                <tr>
                                    <td>Sub Total</td>
                                    <td><div className='__InpMss_bx'></div></td>
                                    <td>₹{form.sub_total}</td>
                                </tr>

                                <tr>
                                    <td>Discount on Bill</td>
                                    <td>
                                        <div className='__InpMss_bx'>
                                            <input
                                                type="text"
                                                placeholder='0.00'
                                                value={form.discount ? form.discount : ""}
                                                onChange={({ target: { name, value } }) => {
                                                    if (/^0[0-9]/.test(value)) {
                                                        value = value.replace(/^0+/, ''); // "01" → "1"
                                                    }

                                                    // Allow "0." for decimals but not "0x" where x is digit
                                                    if (value === "0") {
                                                        handleInputChange("discount", value);
                                                        return;
                                                    }
                                                    handleInputChange('discount', value)
                                                }}
                                                min="0"
                                                step="0.01"
                                                onKeyDown={handleKeyDown}
                                                maxLength={10}
                                            />
                                        </div>

                                    </td>
                                    <td>-₹{Number(form.discount).toFixed(2)}</td>
                                </tr>

                                <tr>
                                    <td>TDS</td>
                                    <td>
                                        <div className='__InpMss_bx'>
                                            <input
                                                type="text"
                                                placeholder='0.00'
                                                value={form.tds ? form.tds : ""}
                                                // onChange={(e) => handleInputChange('tds', e.target.value)}
                                                onChange={({ target: { name, value } }) => {
                                                    if (/^0[0-9]/.test(value)) {
                                                        value = value.replace(/^0+/, ''); // "01" → "1"
                                                    }

                                                    // Allow "0." for decimals but not "0x" where x is digit
                                                    if (value === "0") {
                                                        handleInputChange("tds", value);
                                                        return;
                                                    }
                                                    handleInputChange('tds', value)
                                                }}
                                                min="0"
                                                step="0.01"
                                                onKeyDown={handleKeyDown}
                                                maxLength={10}
                                            />
                                        </div>
                                    </td>
                                    <td>-₹{Number(form.tds).toFixed(2)}</td>
                                </tr>

                                <tr>
                                    <td>Adjustment</td>
                                    <td>
                                        <div className='__InpMss_bx'>
                                            <input
                                                type="text"
                                                placeholder='0.00'
                                                value={form.adjustment ? form.adjustment : ""}
                                                // onChange={(e) => handleInputChange('adjustment', e.target.value)}
                                                onChange={({ target: { name, value } }) => {
                                                    if (/^0[0-9]/.test(value)) {
                                                        value = value.replace(/^0+/, ''); // "01" → "1"
                                                    }

                                                    // Allow "0." for decimals but not "0x" where x is digit
                                                    if (value === "0") {
                                                        handleInputChange("adjustment", value);
                                                        return;
                                                    }
                                                    handleInputChange('adjustment', value)
                                                }}
                                                step="0.01"
                                                // onKeyDown={handleKeyDown}
                                                maxLength={10}

                                            />
                                        </div>
                                    </td>
                                    <td>
                                        {Number(form.adjustment || 0) < 0
                                            ? `-₹${Math.abs(Number(form.adjustment)).toFixed(2)}`
                                            : `₹${Number(form.adjustment || 0).toFixed(2)}`
                                        }
                                    </td>

                                </tr>
                            </tbody>

                            <tfoot>
                                <tr>
                                    <td><strong>Total</strong></td>
                                    <td></td>
                                    <td><strong>₹{Number(form.total_amount).toFixed(2)}</strong></td>
                                </tr>
                            </tfoot>
                        </table>
                        <div className="_lrCl_offCavBody">
                            <div className="singleDiv">
                                <div className="_payMode_hed">
                                    <h4> Payment Mode </h4>

                                    <div className='checkBx_lv p-0 mt-0' style={{ width: '100%' }}>
                                        {
                                            constant.isPaymentKey?.map((el, ind) => {
                                                return (
                                                    <React.Fragment key={ind}>
                                                        <div className='_dualCheckr_bx mt-2' style={{ maxWidth: '140px', width: '100%' }}>
                                                            <input
                                                                style={{ marginTop: '2px' }}
                                                                className="form-check-input"
                                                                id={+ind + "payment_mode" + el?.value}
                                                                type="radio"
                                                                name="payment_mode"
                                                                checked={form?.payment_mode === el?.value}
                                                                value={el?.value}
                                                                onChange={(e) => handleInputChange('payment_mode', el?.value)}
                                                            />
                                                            <label style={{ fontSize: '14px' }} htmlFor={+ind + "payment_mode" + el.value} className="form-check-label" >
                                                                {el.label}
                                                            </label>
                                                        </div>
                                                    </React.Fragment>
                                                )
                                            })
                                        }
                                    </div>

                                    {(!form?.is_invoice ? expenseAccount.filter(f => f.value != 15) : expenseAccount)
                                        .map((i, index) => (
                                            <React.Fragment key={i + '' + index}>
                                                <button
                                                    className={`_baseSpan mt-2 ${i?.value == form?.account_sub_category ? "" : "_bspDisable"
                                                        }`}
                                                    disabled={accountLoading}
                                                    name="account_sub_category"
                                                    value={i.value}
                                                    onClick={({ target: { name, value } }) => {
                                                        handleInputChange(name, value);
                                                    }}
                                                >
                                                    {i.label}
                                                </button>
                                            </React.Fragment>
                                        ))
                                    }

                                    {/* <button className="_baseSpan _bspDisable" >Balance</button> */}
                                </div>
                            </div>

                            {(form?.account_sub_category != 11 &&
                                form?.account_sub_category != 15) && (
                                    <>
                                        {!accountLoading ? (
                                            <div className="singleDiv">
                                                <CustomSelect
                                                    label="Select Account"
                                                    name="account_id"
                                                    onSelect={(data) => {
                                                        handleInputChange("account_id", data.value);
                                                        setBankRequiredDetails(data)
                                                    }}
                                                    value={
                                                        form?.account_id
                                                            ? accountList?.find((i) => i.value == form?.account_id)
                                                            : { label: "", value: "" }
                                                    }
                                                    options={accountList}
                                                    focus={!!formErrors?.account_id}
                                                    error={formErrors.account_id}
                                                    isAddButton={form?.account_sub_category == 2}
                                                    addButtonAction={addAccountHandle}
                                                />
                                            </div>
                                        ) : (
                                            <SkeletonInput isLoading={accountLoading} />
                                        )}
                                    </>
                                )}
                            {form?.is_invoice && <> {(form?.account_sub_category == 2 || form?.account_sub_category == 27 || form?.account_sub_category == 28) && form?.vendor_type && (
                                <div>
                                    <input
                                        type="checkbox"
                                        id="vehicle1"
                                        name="vehicle1"
                                        checked={isCheck}
                                        disabled={bankRequiredDetails?.vendor_account === true}
                                        onChange={({ target: { name, checked } }) => {
                                            if (form?.account_sub_category == 2 && !form?.vendor_id?.value) {
                                                toast.error("Please select vendor first")
                                                return
                                            } else {
                                                setIsCheck(checked);
                                            }
                                            handleInputChange("isCheck", checked);
                                        }}

                                    />
                                    <label htmlFor="vehicle1"> {`Select Bank Account`}</label>
                                    <br />
                                </div>
                            )}

                                {(form?.account_sub_category == 2 || form?.account_sub_category == 28) && (
                                    <div className="singleDiv"
                                        onClick={() => {
                                            if (form?.vendor_id?.value) {
                                                setCanvasOpen(true);
                                                venderDetailsFun({ vender_type: form?.vendor_type, vender_id: form?.vendor_id })
                                            } else {
                                                toast.error("Please select vendor first")
                                            }
                                        }}
                                    >
                                        <CustomSelect
                                            label={"Select Bank Account"}
                                            options={bankAccountList}
                                            disabled={!isCheck}
                                            openList={false}
                                            value={
                                                bankDetails
                                                    ? bankAccountList?.find(
                                                        (i) => i?.value === bankDetails?._id
                                                    )
                                                    : { label: "", value: "" }
                                            }
                                            focus={!!formErrors?.vendor_bank_account}
                                            error={formErrors.vendor_bank_account}

                                        />
                                    </div>
                                )}</>}

                        </div>
                    </div>
                </div>

            </div>

            <div className='bottomFix chaliBtnBx'>
                {!state?.data?._id && <button
                    className="_addComm_btn anime-btn"
                    type="button"
                    style={{ maxWidth: '110px', width: '100%' }}
                    disabled={loading}

                    onClick={handleSubmit}

                >
                    {loading ? "Proccessing.." : form?.account_sub_category == 28 ? "Pay Now" : "Save"}
                </button>}
                <button
                    className="_cancel_btn anime-btn"
                    type="button"
                    style={{ maxWidth: '110px', width: '100%' }}
                    disabled={loading}
                    onClick={() => navigate("/WorkshopServicing")}
                >
                    Cancel
                </button>
            </div>

            {/* Add Expense Modal */}
            {showModal && <AddExpenseServiceModal
                {...expenseProps}
            />}
            {showModalPart && <AddWorkShopItemModal {...expensePropsPart} />}
            {canvasOpen && <BankListCanvas {...bankListProps} />}
            {showAddBank && <AddBankAccount {...firstAddBank} />}
            {accountAddShow && <AddAccountingAccount {...AddTransactionAccountModal} />}
            {payNowAccountCreate && <PayNowAccountNotifyModal {...payNowAccountProps} />}
            {isOpenPayNow && <PaymentConfirmModal {...payNowProps} />}
            <div className={isOpenPayNow ? "offBack_drop" : ""}></div>
            <div
                className={`offcanvas offcanvas-end common_offCanvas ${showOffcanvas ? "show" : ""
                    }`}
                tabIndex={-1}
                style={{ visibility: showOffcanvas ? "visible" : "hidden" }}
            >
                {showOffcanvas && (
                    <AddEditVehicleModal
                        isOpen={showOffcanvas}
                        onClose={() => setShowOffcanvas(false)}
                        callBackVehicle={callBackVehicle}
                        isDriver={isDriver}
                        handleAddNewVehicleButtonAction={
                            handleAddNewVehicleButtonAction
                        }
                        showOnlyOwn_Leased={false}
                        hideAddNewOption={false}
                    />
                )}
            </div>

            <div className={showOffcanvas ? "offBack_drop" : ""}></div>


            <div
                className={`offcanvas offcanvas-end common_offCanvas ${showOffcanvasOfDriver ? "show" : ""
                    }`}
                tabIndex={-1}
                style={{ visibility: showOffcanvasOfDriver ? "visible" : "hidden" }}
            >
                {showOffcanvasOfDriver && (
                    <AddEditOwnDriver
                        isOpen={showOffcanvasOfDriver}
                        onClose={() => setShowOffcanvasOfDriver(false)}
                        callBackDriver={(e) => handleDriverNextModal(e)}
                        hideAddNewOption={false}
                    />
                )}
            </div>
            <div className={showOffcanvasOfDriver ? "offBack_drop" : ""}></div>

            {/* Vender modal */}

            <div
                className={`offcanvas offcanvas-end common_offCanvas ${showOffcanvasVendor ? 'show' : ''}`}
                tabIndex={-1}
                style={{ visibility: showOffcanvasVendor ? 'visible' : 'hidden' }}
            >
                {showOffcanvasVendor &&
                    <AddEditVendors
                        isOpen={showOffcanvasVendor}
                        onClose={(e) => setShowOffcanvasVendor(false)}
                        callBackVendor={callBackVendor}
                        hideAddNewOption={false}
                    />
                }
            </div>
            <div className={showOffcanvasVendor ? 'offBack_drop' : ''}></div>

        </div>
    )
}

export default AddService

